// src/components/GalleryCategories.jsx
import React, { useState } from "react";
import "./GalleryCategories.css";

const categories = ["All", "Education", "Health Camps", "Women Empowerment", "Disaster Relief"];

const GalleryCategories = ({ onCategoryChange }) => {
  const [activeCategory, setActiveCategory] = useState("All");

  const handleCategoryClick = (category) => {
    setActiveCategory(category);
    onCategoryChange(category);
  };

  return (
    <div className="gallery-categories">
      {categories.map((category) => (
        <button
          key={category}
          className={`category-btn ${activeCategory === category ? "active" : ""}`}
          onClick={() => handleCategoryClick(category)}
        >
          {category}
        </button>
      ))}
    </div>
  );
};

export default GalleryCategories;
